import { html } from './utils/environment';

export default function() {

    // Browser detection
    // ==========================================================================
    const browserParser = bowser.getParser(window.navigator.userAgent);
    const browser = browserParser.getBrowser()

    if(browser.name === "Internet Explorer") {
        html.classList.add('is-ie')
    } else if(browser.name === "Firefox") {
        html.classList.add('is-firefox')
    } else if(browser.name === "Safari") {
        html.classList.add('is-safari')
    }
}
